import styles from './Tile.module.scss';
import React, { ReactElement } from 'react';

interface Props {
  text: string;
  value: number;
}

export const Tile = ({ text, value }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.title}>{text}</div>
        <div className={styles.count}>{value}</div>
      </div>
    </div>
  );
};
